import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import EventsBanner from "./EventsBanner";
import EventWithUs from "./EventWithUs";
import FeaturedEvents from "./FeaturedEvents";
import UpcomingEvents from "./UpcomingEvents";
//import NativeAd from "../common/NativeAd";
import axios from "axios";
import { store } from "../../app/store";
import { useDispatch } from "react-redux";
import { resetSale } from "../../app/features/event/eventSlice";
import { resetTimer } from "../../app/features/timer/timerSlice";
import { resetAskSignup, resetGuest, setAskTicket } from "../../app/features/user/userSlice";
import { useQuery } from "react-query";
// import BannerImage from "../../gallery/banner.jpg";

const EventsIndex = React.memo(function EventsIndex(props) {
  const dispatch = useDispatch();

  const { data: locations } = useQuery({
    queryKey: ["locations"],
    queryFn: async () => {
      const response = await axios.request({
        method: "GET",
        url: process.env.REACT_APP_BASE_URL + "/api/locations",
        headers: {
          Authorization: process.env.REACT_APP_API_KEY,
        },
        params: {
          page: 1,
          limit: 300,
        },
      });
      return response.data.data;
    },
  });
  function toggleMobilenav() {
    var body = document.body;
    var hasClass = body.classList.contains("nav2-is-toggled");
    if (hasClass) {
      document.body.classList.remove("nav2-is-toggled");
      document.body.classList.remove("body-no-scroll");
      document.getElementById("ham").textContent = "menu";
    }
  }

  const handleModalClose = async () => {
    const currentItems = store.getState().event.items;
    const tickets = Object.values(currentItems).reduce((acc, el) => {
      if (el != null) {
        acc.push({
          ticket_id: el.ticket_id,
          quantity: el.quantity,
        });
      }
      return acc;
    }, []);

    await axios.request({
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL}/api/unhold_tickets`,
      data: { tickets: tickets },
      headers: {
        Authorization: process.env.REACT_APP_API_KEY,
      },
    });
    dispatch(resetSale());
    dispatch(resetTimer());
    dispatch(setAskTicket());
    dispatch(resetAskSignup());
    dispatch(resetGuest());
  };
  function useCleanModalBackdrop(modalId) {
    const modalEl = document.getElementById(modalId);

    if (!modalEl) {
      // If modal doesn't exist, remove any stuck backdrops
      const backdrops = document.querySelectorAll(".modal-backdrop");
      backdrops.forEach((el) => el.remove());
      document.body.classList.remove("modal-open");
      document.body.style.removeProperty("overflow");
      document.body.style.removeProperty("padding-right");
    }
  }

  useEffect(() => {
    handleModalClose();
    useCleanModalBackdrop("exampleModalToggle");
    toggleMobilenav();
  }, []);
  return (
    <>
      <Helmet>
        <title>{`Sahi Search - ${props.pageTitle}`}</title>
        <meta name="description" content="" />
      </Helmet>
      <EventsBanner locations={locations} />
      <div className="container">
        <FeaturedEvents />
      </div>
      {/* <NativeAd /> */}
      <UpcomingEvents locations={locations} />
      {/* <NativeAd /> */}
      <EventWithUs />
    </>
  );
});

export default EventsIndex;
